

import { useState } from 'react';

export const ConsentFormSection: React.FC = () => {
  const handleMSFormRedirect = () => {
    window.open('https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAO__dONQBBURUtWTjZaV1FON1pSNThBWEIwVFdJTjMyRi4u', '_blank');
  };

  return (
    <section className="py-16 bg-gray-50" id="consent-form">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">참여 동의서 작성하기</h2>
          <p className="text-lg text-gray-600">
            대청마을 북측구역 통합개발 사업에 참여하시려면 아래 동의서를 작성해 주세요.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="bg-gray-50 p-6 rounded-lg mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">관리계획 수립 동의서</h3>
            <div className="text-sm text-gray-700 space-y-2">
              <p>• 본인은 대청마을 북측구역 통합개발 사업의 관리계획 수립에 동의합니다.</p>
              <p>• 사업 추진 과정에서 필요한 각종 절차와 계획 수립에 협조하겠습니다.</p>
              <p>• 관련 법령과 절차에 따라 진행되는 사업에 성실히 참여하겠습니다.</p>
              <p>• 제출한 개인정보는 사업 목적으로만 사용됨을 이해합니다.</p>
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={handleMSFormRedirect}
              className="bg-blue-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-external-link-line mr-2"></i>
              관리계획 수립 동의서 작성하기
            </button>
          </div>

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-500">
              주관기관: 대청마을 북측 모아타운 사업성 평가 위원회
            </p>
            <p className="text-xs text-gray-400 mt-2">
              * 새 창에서 Microsoft Forms로 이동합니다
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

